module.exports = __webpack_public_path__ + "img/playground.f66578ba.svg";